import { render } from "./MyLeadsNumCard.vue?vue&type=template&id=70f820aa"
import script from "./MyLeadsNumCard.vue?vue&type=script&lang=js"
export * from "./MyLeadsNumCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__